import { useHistory } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { formattedTime } from "../../components/formatted/FormattedDateAndTime";
import { buildNotificationDetailState } from "../notificationUtils";
import { formatAnomalyNotificationDescription } from "./notificationDisplayUtils";
import { getNotificationTypeLabel } from "./notificationTypeUtils";

const NotificationListRow = ({ notification }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const typeLabel = getNotificationTypeLabel(notification.type, t);
  const description = formatAnomalyNotificationDescription(
    notification.description,
  );
  const metaParts = [notification.wasteName, notification.addressName].filter(
    Boolean,
  );

  const openDetails = () => {
    history.push(
      "/app/notificationsdetails",
      buildNotificationDetailState(notification),
    );
  };

  return (
    <button
      type="button"
      className={`notification-row-card${notification.read ? "" : " notification-row-card-unread"}`}
      onClick={openDetails}
    >
      <div className="notification-row-card-body">
        <div className="notification-row-card-top">
          <span className="notification-row-eyebrow">{typeLabel}</span>
          <span className="notification-row-time">
            {formattedTime(notification.date)}
          </span>
        </div>
        <p className="notification-row-title">{description}</p>
        {metaParts.length > 0 && (
          <p className="notification-row-meta">{metaParts.join(" · ")}</p>
        )}
      </div>

      <span className="notification-row-chevron" aria-hidden>
        <FaChevronRight />
      </span>
    </button>
  );
};

export default NotificationListRow;
